var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useMemo, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import _ from "lodash";
import { api } from "../../../services/http.service";
import { env } from "../../../constants/global.constants";
import "./homeGridSlider.css";
export function HomeGridSlider() {
    var _a = useState([]), slides = _a[0], setSlides = _a[1];
    var _b = useState([]), processedSlides = _b[0], setProcessedSlides = _b[1];
    var swiperRef = useRef(null);
    useEffect(function () {
        api.start("get", env.accounting_api + "/misc/api/list-slide/", null, false).then(function (res) {
            var slideData = _.orderBy(res.data, ["ordering"], ["asc"]);
            // Filter only active slides with slide_page 0
            var activeSlides = slideData.filter(function (slide) { return slide.is_active === true && slide.slide_page === 0; });
            setSlides(activeSlides);
        });
    }, []);
    useEffect(function () {
        if (!slides.length)
            return;
        var newSlides = [];
        var loadedCount = 0;
        slides.forEach(function (item, idx) {
            var img = new Image();
            var rawPath = item.photo_web || item.photo_mobile || "";
            var fullUrl = rawPath.startsWith("http") ? rawPath : "".concat(env.accounting_api, "/media/").concat(rawPath);
            img.src = fullUrl;
            img.onload = function () {
                var isPortrait = img.naturalHeight > img.naturalWidth;
                newSlides[idx] = __assign(__assign({}, item), { url: fullUrl, href: item.web_url || item.mobile_url || "#", alt: item.content || item.title || "Slide-".concat(item.id), col: isPortrait ? 2 : 5 });
                loadedCount++;
                if (loadedCount === slides.length) {
                    setProcessedSlides(newSlides.filter(Boolean));
                }
            };
            img.onerror = function () {
                // fallback or skip
                newSlides[idx] = __assign(__assign({}, item), { url: fullUrl, href: item.web_url || item.mobile_url || "#", alt: item.content || item.title || "Slide-".concat(item.id), col: 5 });
                loadedCount++;
                if (loadedCount === slides.length) {
                    setProcessedSlides(newSlides.filter(Boolean));
                }
            };
        });
    }, [slides]);
    var groupedSlides = useMemo(function () {
        var groups = [];
        var currentGroup = [];
        var currentWidth = 0;
        var clone = __spreadArray([], processedSlides, true);
        // Eğer ilk üç slide 5-2-5 ise özel grup
        if (clone.length >= 3 &&
            clone[0].col === 5 &&
            clone[1].col === 2 &&
            clone[2].col === 5) {
            groups.push(clone.splice(0, 3));
        }
        clone.forEach(function (slide) {
            if (currentWidth + slide.col > 12) {
                groups.push(currentGroup);
                currentGroup = [];
                currentWidth = 0;
            }
            currentGroup.push(slide);
            currentWidth += slide.col;
        });
        if (currentGroup.length) {
            groups.push(currentGroup);
        }
        return groups;
    }, [processedSlides]);
    var SLIDE_HEIGHT = 350;
    return (_jsx("div", __assign({ style: { marginBottom: "20px", borderRadius: "8px", overflow: "hidden" } }, { children: _jsxs("div", __assign({ className: "custom-navigation" }, { children: [_jsx(Swiper, __assign({ modules: [Navigation], spaceBetween: 8, onSwiper: function (swiper) {
                        swiperRef.current = swiper;
                    }, className: "homeGridSlider" }, { children: groupedSlides.map(function (group, idx) { return (_jsx(SwiperSlide, { children: _jsx("div", __assign({ className: "slide-row", style: {
                                display: "flex",
                                width: "100%",
                                height: "".concat(SLIDE_HEIGHT, "px"),
                                gap: "20px",
                            } }, { children: group.map(function (item, subIdx) { return (_jsx("a", __assign({ href: item.href, "aria-label": item.alt, style: {
                                    flex: item.col,
                                    display: "flex",
                                    height: "100%",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                } }, { children: _jsx("img", { src: item.url, alt: item.alt, style: {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                    } }) }), subIdx)); }) })) }, idx)); }) })), _jsxs("div", __assign({ className: "custom-nav-button prev", onClick: function () { var _a; return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); } }, { children: [_jsx("div", { className: "button-bg" }), _jsx("div", __assign({ className: "arrow-container" }, { children: _jsx("img", { src: "/assets/icon/arrow-back.svg", alt: "Previous", className: "arrow-icon" }) }))] })), _jsxs("div", __assign({ className: "custom-nav-button next", onClick: function () { var _a; return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext(); } }, { children: [_jsx("div", { className: "button-bg" }), _jsx("div", __assign({ className: "arrow-container" }, { children: _jsx("img", { src: "/assets/icon/arrow-back.svg", alt: "Next", className: "arrow-icon" }) }))] }))] })) })));
}
